function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var p = Object.defineProperty;
var A = Object.getOwnPropertyDescriptor;
var E = Object.getOwnPropertyNames;
var N = Object.prototype.hasOwnProperty;

var R = function R(i) {
  return p(i, "__esModule", {
    value: !0
  });
};

var L = function L(i, n) {
  for (var s in n) {
    p(i, s, {
      get: n[s],
      enumerable: !0
    });
  }
},
    x = function x(i, n, s, o) {
  if (n && typeof n == "object" || typeof n == "function") {
    var _iterator = _createForOfIteratorHelper(E(n)),
        _step;

    try {
      var _loop = function _loop() {
        var _ = _step.value;
        !N.call(i, _) && (s || _ !== "default") && p(i, _, {
          get: function get() {
            return n[_];
          },
          enumerable: !(o = A(n, _)) || o.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return i;
};

var f = function (i) {
  return function (n, s) {
    return i && i.get(n) || (s = x(R({}), n, 1), i && i.set(n, s), s);
  };
}(typeof WeakMap != "undefined" ? new WeakMap() : 0);

var O = {};
L(O, {
  EthChainType: function EthChainType() {
    return T;
  },
  MagicIncomingWindowMessage: function MagicIncomingWindowMessage() {
    return c;
  },
  MagicOutgoingWindowMessage: function MagicOutgoingWindowMessage() {
    return I;
  },
  MagicPayloadMethod: function MagicPayloadMethod() {
    return r;
  },
  RPCErrorCode: function RPCErrorCode() {
    return l;
  },
  SDKErrorCode: function SDKErrorCode() {
    return u;
  },
  SDKWarningCode: function SDKWarningCode() {
    return g;
  }
});

var u = function (a) {
  return a.MissingApiKey = "MISSING_API_KEY", a.ModalNotReady = "MODAL_NOT_READY", a.MalformedResponse = "MALFORMED_RESPONSE", a.InvalidArgument = "INVALID_ARGUMENT", a.ExtensionNotInitialized = "EXTENSION_NOT_INITIALIZED", a.IncompatibleExtensions = "INCOMPATIBLE_EXTENSIONS", a;
}(u || {}),
    g = function (_) {
  return _.SyncWeb3Method = "SYNC_WEB3_METHOD", _.DuplicateIframe = "DUPLICATE_IFRAME", _.ReactNativeEndpointConfiguration = "REACT_NATIVE_ENDPOINT_CONFIGURATION", _.DeprecationNotice = "DEPRECATION_NOTICE", _;
}(g || {}),
    l = function (e) {
  return e[e.ParseError = -32700] = "ParseError", e[e.InvalidRequest = -32600] = "InvalidRequest", e[e.MethodNotFound = -32601] = "MethodNotFound", e[e.InvalidParams = -32602] = "InvalidParams", e[e.InternalError = -32603] = "InternalError", e[e.MagicLinkFailedVerification = -1e4] = "MagicLinkFailedVerification", e[e.MagicLinkExpired = -10001] = "MagicLinkExpired", e[e.MagicLinkRateLimited = -10002] = "MagicLinkRateLimited", e[e.MagicLinkInvalidRedirectURL = -10006] = "MagicLinkInvalidRedirectURL", e[e.UserAlreadyLoggedIn = -10003] = "UserAlreadyLoggedIn", e[e.UpdateEmailFailed = -10004] = "UpdateEmailFailed", e[e.UserRequestEditEmail = -10005] = "UserRequestEditEmail", e[e.InactiveRecipient = -10010] = "InactiveRecipient", e[e.AccessDeniedToUser = -10011] = "AccessDeniedToUser", e;
}(l || {});

var r = function (t) {
  return t.LoginWithSms = "magic_auth_login_with_sms", t.LoginWithEmailOTP = "magic_auth_login_with_email_otp", t.LoginWithMagicLink = "magic_auth_login_with_magic_link", t.LoginWithCredential = "magic_auth_login_with_credential", t.GetIdToken = "magic_auth_get_id_token", t.GenerateIdToken = "magic_auth_generate_id_token", t.GetMetadata = "magic_auth_get_metadata", t.IsLoggedIn = "magic_auth_is_logged_in", t.Logout = "magic_auth_logout", t.UpdateEmail = "magic_auth_update_email", t.UserSettings = "magic_auth_settings", t.UserSettingsTestMode = "magic_auth_settings_testing_mode", t.LoginWithSmsTestMode = "magic_auth_login_with_sms_testing_mode", t.LoginWithEmailOTPTestMode = "magic_auth_login_with_email_otp_testing_mode", t.LoginWithMagicLinkTestMode = "magic_login_with_magic_link_testing_mode", t.LoginWithCredentialTestMode = "magic_auth_login_with_credential_testing_mode", t.GetIdTokenTestMode = "magic_auth_get_id_token_testing_mode", t.GenerateIdTokenTestMode = "magic_auth_generate_id_token_testing_mode", t.GetMetadataTestMode = "magic_auth_get_metadata_testing_mode", t.IsLoggedInTestMode = "magic_auth_is_logged_in_testing_mode", t.LogoutTestMode = "magic_auth_logout_testing_mode", t.UpdateEmailTestMode = "magic_auth_update_email_testing_mode", t;
}(r || {});

var c = function (m) {
  return m.MAGIC_HANDLE_RESPONSE = "MAGIC_HANDLE_RESPONSE", m.MAGIC_OVERLAY_READY = "MAGIC_OVERLAY_READY", m.MAGIC_SHOW_OVERLAY = "MAGIC_SHOW_OVERLAY", m.MAGIC_HIDE_OVERLAY = "MAGIC_HIDE_OVERLAY", m.MAGIC_HANDLE_EVENT = "MAGIC_HANDLE_EVENT", m;
}(c || {}),
    I = function (n) {
  return n.MAGIC_HANDLE_REQUEST = "MAGIC_HANDLE_REQUEST", n;
}(I || {});

var T = function (n) {
  return n.Harmony = "HARMONY", n;
}(T || {});

module.exports = f(O);